<template>
  <div v-if="!friendsAndFamily">
    <b-row id="edit-column-width" style="margin-right:0px;">
      <b-col :sm="colWidth">
        <div class="form-horizontal">
          <h3 class="section-heading mb-5">Your Home Page</h3>

          <div class="form-group form-group-venue">
            <b-row>
              <label for="welcomeTitle" class="col-sm-2 control-label"
                >Your Welcome Title:</label
              >
              <b-col sm="10">
                <b-form-input
                  type="text"
                  class="form-control"
                  id="WelcomeTitle"
                  placeholder="Welcome Title"
                  v-model="$store.state.user.couple_title"
                ></b-form-input>
              </b-col>
            </b-row>
          </div>

          <div class="form-group form-group-venue">
            <b-row>
              <label class="col-sm-2 control-label" for="YourMessage"
                >Your Welcome Message:</label
              >
              <b-col sm="10">
                <rich-text-editor
                  v-model="$store.state.user.welcome_message"
                  :init="{
                    height: 200,
                    menubar: false,
                    plugins: 'advlist autolink lists link image charmap anchor searchreplace visualblocks code fullscreen insertdatetime media table help wordcount',
                    toolbar: 'undo redo | blocks | bold italic backcolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | removeformat | help'
                  }"
                />
              </b-col>
            </b-row>
          </div>

          <hr />
          <h3
            v-if="$store.state.wishlistType === 'wishlist'"
            class="text-center mb-3"
          >
            Your Wedding Day
          </h3>
          <h3
            v-if="$store.state.wishlistType === 'giftlist'"
            class="text-center mb-3"
          >
            Your Celebration Day
          </h3>

          <div
            class="form-group form-group-venue"
            v-if="$store.state.wishlistType !== 'giftlist'"
          >
            <b-row>
              <label
                class="col-sm-12 control-label"
                style="text-align: left; margin-bottom: 30px; font-size:20px; 'Alegreya', Georgia, Time Roman, serif;"
                >Ceremony Venue:
              </label>
            </b-row>
          </div>

          <div
            class="form-group form-group-venue"
            v-if="$store.state.wishlistType !== 'giftlist'"
          >
            <b-row>
              <label for="Time" class="col-sm-2 control-label">Time:</label>
              <b-col sm="10">
                <input
                  type="text"
                  class="form-control"
                  id="Time"
                  placeholder="Time"
                  v-model="$store.state.user.wedding_day.time"
                />
              </b-col>
            </b-row>
          </div>

          <div
            class="form-group form-group-venue"
            v-if="$store.state.wishlistType !== 'giftlist'"
          >
            <b-row>
              <label for="Date" class="col-sm-2 control-label">Date:</label>
              <b-col sm="10">
                <input
                  type="text"
                  class="form-control"
                  id="Date"
                  placeholder="Date"
                  v-model="$store.state.user.wedding_day.date"
                />
              </b-col>
            </b-row>
          </div>

          <div
            class="form-group form-group-venue"
            v-if="$store.state.wishlistType !== 'giftlist'"
          >
            <b-row>
              <label for="Name" class="col-sm-2 control-label">Name:</label>
              <b-col sm="10">
                <input
                  type="text"
                  class="form-control"
                  id="Name"
                  placeholder="Name"
                  v-model="$store.state.user.wedding_day.name"
                />
              </b-col>
            </b-row>
          </div>

          <div
            class="form-group form-group-venue"
            v-if="$store.state.wishlistType !== 'giftlist'"
          >
            <b-row>
              <label for="Address" class="col-sm-2 control-label"
                >Address:</label
              >
              <b-col sm="10">
                <input
                  type="text"
                  class="form-control"
                  id="Address"
                  placeholder="Address"
                  v-model="$store.state.user.wedding_day.address"
                />
              </b-col>
            </b-row>
          </div>

          <div
            class="form-group form-group-venue"
            v-if="$store.state.wishlistType !== 'giftlist'"
          >
            <b-row>
              <label for="Website" class="col-sm-2 control-label"
                >Website:</label
              >
              <b-col sm="10">
                <input
                  type="text"
                  class="form-control"
                  id="Website"
                  placeholder="Website"
                  v-model="$store.state.user.wedding_day.website"
                />
              </b-col>
            </b-row>
          </div>

          <hr v-if="$store.state.wishlistType !== 'giftlist'" />

          <div class="form-group form-group-venue">
            <b-row>
              <label
                class="col-sm-12 control-label"
                style="text-align: left; margin-bottom: 30px; font-size:20px; 'Alegreya', Georgia, Time Roman, serif;"
                >Reception Venue:
              </label>
            </b-row>
          </div>

          <div class="form-group form-group-venue">
            <b-row>
              <label for="WedNightTime" class="col-sm-2 control-label"
                >Time:</label
              >
              <b-col sm="10">
                <input
                  type="text"
                  class="form-control"
                  id="WedNightTime"
                  placeholder="Time"
                  v-model="$store.state.user.wedding_night.time"
                />
              </b-col>
            </b-row>
          </div>

          <div class="form-group form-group-venue">
            <b-row>
              <label for="Date" class="col-sm-2 control-label">Date:</label>
              <b-col sm="10">
                <input
                  type="text"
                  class="form-control"
                  id="DateNt"
                  placeholder="Date"
                  v-model="$store.state.user.wedding_night.date"
                />
              </b-col>
            </b-row>
          </div>

          <div class="form-group form-group-venue">
            <b-row>
              <label for="WedName" class="col-sm-2 control-label">Name:</label>
              <b-col sm="10">
                <input
                  type="text"
                  class="form-control"
                  id="NameNt"
                  placeholder="Name"
                  v-model="$store.state.user.wedding_night.name"
                />
              </b-col>
            </b-row>
          </div>

          <div class="form-group form-group-venue">
            <b-row>
              <label for="Address" class="col-sm-2 control-label"
                >Address:</label
              >
              <b-col sm="10">
                <input
                  type="text"
                  class="form-control"
                  id="AddressNt"
                  placeholder="Address"
                  v-model="$store.state.user.wedding_night.address"
                />
              </b-col>
            </b-row>
          </div>

          <div class="form-group form-group-venue">
            <b-row>
              <label for="Website" class="col-sm-2 control-label"
                >Website:</label
              >
              <b-col sm="10">
                <input
                  type="text"
                  class="form-control"
                  id="WebsiteNt"
                  placeholder="Website"
                  v-model="$store.state.user.wedding_night.website"
                />
              </b-col>
            </b-row>
          </div>

          <hr />

          <div class="form-group form-group-venue">
            <b-row>
              <label
                class="col-sm-12 control-label"
                style="text-align: left; margin-bottom: 30px; font-size:20px;"
                >Where to Stay:
              </label>
            </b-row>
          </div>

          <span v-for="(item, index) in $store.state.user.where_to_stay" :key="index =1000">
            <div class="form-group form-group-venue" :key="index">
              <b-row>
                <label for="Name" class="col-sm-2 control-label"
                  >Name {{ index + 1 }}:</label
                >
                <b-col sm="10">
                  <b-form-input
                    type="text"
                    v-model="item.name"
                    id="Firstname"
                    style=" border-radius:5px"
                    placeholder="Name"
                  >
                  </b-form-input>
                </b-col>
              </b-row>
            </div>

            <div class="form-group form-group-venue " :key="index + 10">
              <b-row>
                <label for="Url" class="col-sm-2 control-label"
                  >URL {{ index + 1 }}:</label
                >
                <b-col sm="8" class="mt-1">
                  <b-form-input
                    type="text"
                    v-model="item.url"
                    id="URL"
                    style=" border-radius:5px"
                    placeholder="URL"
                  >
                  </b-form-input>
                </b-col>
                <!-- <b-col sm="1" /> -->
                <b-col sm="2" class="pl-2">
                  <button
                    v-if="$store.state.wishlistType === 'giftlist'"
                    class="btn btn-sm float-end mt-1"
                    style="background-color: orange; color: white;"
                    @click="onClicker('minus')"
                  >
                    Remove
                  </button>
                  <button
                    v-else
                    class="btn btn-sm float-end mt-1"
                    style="background-color: pink; color: white;"
                    @click="onClicker('minus')"
                  >
                    Remove
                  </button>
                </b-col>
              </b-row>
            </div>
          </span>

          <b-row v-if="$store.state.user.where_to_stay.length < 3">
            <b-col sm="2"></b-col>
            <b-col sm="10">
              <a
                v-if="$store.state.wishlistType === 'giftlist'"
                type="button"
                @click="onClicker('plus')"
                class="btn btn-lg btn-block"
                style="background-color: orange; color: white;"
                >Add Accommodation</a
              >
              <a
                v-else
                type="button"
                @click="onClicker('plus')"
                class="btn btn-lg btn-block"
                style="background-color: pink; color: white;"
                >Add Accommodation</a
              >
            </b-col>
          </b-row>

          <hr />

          <b-row>
            <b-col sm="1"></b-col>
            <b-col sm="10">
              <h3 class="text-center mb-5">Email Alerts</h3>
            </b-col>
          </b-row>

          <div class="form-group form-group-venue">
            <b-row>
              <label for="EmailAlert" class="col-sm-2 control-label"></label>
              <div class="col-sm-10">
                <label class="pb-2"
                  >Would you like us to alert you each time your guests
                  contribute?</label
                >
                <b-form-checkbox
                  v-model="$store.state.user.email_alert"
                  id="checkbox-1"
                  name="tAndC"
                  value="true"
                  unchecked-value="false"
                  size="sm"
                >
                   &nbsp; Yes, I would like an email alert
                </b-form-checkbox>
              </div>
            </b-row>
          </div>
          <!-- style="line-height: 3;margin-left: 35% !important; width: 30%; background-color: orange; color: white;" class="btn  btn-lg btn-block"-->
          <b-row class="mb-3">
            <b-col sm="5"></b-col>
            <b-col sm="2">
              <b-row align-content="center">
                <a
                  v-if="$store.state.wishlistType === 'giftlist'"
                  type="button"
                  @click="onSubmit"
                  style="background-color: orange; color: white; max-width: 90%;
    margin-left: 5%;"
                  class="btn btn-lg"
                  >Save</a
                >
                <a
                  v-else
                  type="button"
                  @click="onSubmit"
                  style="background-color: pink; color: white; max-width: 90%;
    margin-left: 5%;"
                  class="btn btn-lg"
                  >Save</a
                >
              </b-row>
            </b-col>
          </b-row>

          <b-row>
            <b-col sm="2"></b-col>
            <b-col sm="10">
              <div class="error-box">
                <p
                  class="bg-success text-center"
                  style="padding: 15px; width: 80%; margin-left:10%; margin-top: 2%;"
                  v-show="showSuccess"
                >
                  Your update have been sent successfully.
                </p>

                <p
                  class="bg-danger text-center"
                  style="padding: 15px; width: 80%; margin-left:10%; margin-top: 2%;"
                  v-show="showError"
                >
                  There has been an error proccessing your update . please call
                  us on <a :href="`tel:${telNo}`" :data-ga4-label="telNo === '020 7084 6512' ? 'dedicated_honeymoon_team' : null" :data-ga4-category="telNo === '020 7084 6512' ? 'text_link' : null">{{ telNo }}</a>
                </p>
              </div>
            </b-col>
          </b-row>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import RichTextEditor from "@tinymce/tinymce-vue";
import { updateWishlist } from "../../services/api";

export default {
  data() {
    return {
      meta: {
        loaded: true
      },
      isActive: true,
      hasError: false,
      arr: [],
      colWidth: "",
      showSuccess: false,
      showError: false,
      friendsAndFamily: null,
      telNo: null,
      numberOfFields: 0,
      item: {
        name: null,
        url: null
      }
    };
  },
  components: {
    RichTextEditor
  },
  props: ["screenWidth"],
  methods: {
    onClicker(event) {
      if (event === "plus" && this.$store.state.user.where_to_stay.length < 4) {
        this.arr.push({ name: this.item.name, url: this.item.url });
        this.$store.state.user.where_to_stay = this.arr;
        this.$store.dispatch("setUserAction", this.$store.state.user);
      } else {
        this.arr.pop();
        this.$store.state.user.where_to_stay = this.arr;
        this.$store.dispatch("setUserAction", this.$store.state.user);
      }
    },
    async onSubmit() {
      this.showSuccess = false;
      this.showError = false;
      let res = await updateWishlist(
        this.$store.state.wishlistType,
        this.$store.state.user._id,
        this.$store.state.user
      );
      if (res.error) {
        this.showError = true;
      } else {
        this.$store.dispatch("setUserAction", res.data);
        this.showSuccess = true;
      }
    }
  },
  mounted() {
    this.meta.loaded = true;
    this.arr = this.$store.state.user.where_to_stay;
    this.date = Date.now();
    if (this.$route.params.wishlistType === "friends-and-family") {
      this.friendsAndFamily = true;
    }
    if (this.screenWidth <= "1025") {
      this.colWidth = "12";
    } else {
      this.colWidth = "12";
    }
    if (window.location.toString().indexOf("trailfinders.ie") > 0) {
      this.telNo = "01 881 4990";
    } else if (this.$store.state.wishlistType === "giftlist") {
      this.telNo = "020 7408 9008";
    } else {
      this.telNo = "020 7084 6512";
    }
  }
};
</script>
<style>
.section-heading {
  margin-top: 4% !important;
}
.form-horizontal .form-group {
  margin-left: 2px;
  margin-right: 2px;
}
@media only screen and (max-width: 1024px) {
  #edit-column-width {
    /* margin-right: 0% !important; */
    width: auto;
    /* width: 100%; */
  }
}
</style>
